import { Button, Grid2, Typography } from '@mui/material';
import { IdAutoCompleteField } from '../../../shared/components/formfields/IdAutoCompleteField';
import { Grid_Gap, Input_Width } from '../../../shared/constants';
import { useSchoolDropdownOptions } from '../options/SchoolOption';
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToaster } from '../../../shared/utils/ToasterProvider';
import { postAssignCourseToTeachers } from '../../../assets/nodeApi/postApi/postSchoolApi';
import UtItem from '../../../shared/utils/UtList';
import CustomDivider from '../../../shared/utils/CustomDivider';
import { useState } from 'react';

const AssignCourseToTeacher = () => {
   
    const queryClient=useQueryClient()
    const { schoolCourse, schoolTeacher } = useSchoolDropdownOptions();
    const [selectedCourse, setSelectedCourse] = useState({})
    const [selectedTeachers, setSelectedTeachers] = useState([])
    const { showToaster } = useToaster();
    const mutation = useMutation({
        mutationFn: postAssignCourseToTeachers,
    });

    const handleSubmit = (values, { resetForm }) => {
        const obj = {
            event_id: Number(values?.event_id),
            teacher_ids: selectedTeachers.map(item => Number(item.id))
        }
        mutation.mutate(obj, {
            onSuccess: (response) => {
                queryClient.invalidateQueries({ queryKey: ["school/teachers-with-courses"] });
                queryClient.invalidateQueries({ queryKey: ["school/teachers"] });
                showToaster('success', response?.message, 'success')
                resetForm();
                setSelectedCourse([])
                setSelectedTeachers([])
            },
            onError: (err) => {
                console.error(err)
                showToaster(err?.response?.data?.message || 'Error occurred while submitting Form.', 'Error', 'error')
            },
        });
    };

    const handleRemove = (id) => {
        setSelectedTeachers(prev => prev?.filter(item => item?.id !== id));
    };
    const validationSchema = Yup.object().shape({

    });



    return (
        <Formik
            enableReinitialize={true}
            initialValues={{}}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}

        >
            {({ values, resetForm, setFieldValue }) => (
                <Form>
                    <Grid2 container spacing={Grid_Gap}>
                        <Grid2 children size={12}>
                            {selectedCourse && typeof selectedCourse.remaining_seats === "number" && (
                                <Typography>
                                    {selectedCourse.remaining_seats} Teacher seat Remaining
                                </Typography>
                            )}


                            <CustomDivider size={"1rem"} />
                            {selectedTeachers?.map((item, index) => (
                                <UtItem key={index} text={item?.label} onRemove={() => { handleRemove(item?.id) }} />

                            ))}
                        </Grid2>
                        <Grid2 children size={Input_Width}>
                            <Field
                                name="event_id"
                                component={IdAutoCompleteField}
                                options={schoolCourse.options}
                                isLoading={schoolCourse.isLoading}
                                label="Course Name"
                                onValueChange={(newValue) => {
                                    setSelectedCourse(newValue)
                                }}
                                isRequired={true}

                            />
                        </Grid2>
                        <Grid2 children size={Input_Width}>
                            <Field
                                name="teacher"
                                component={IdAutoCompleteField}
                                options={schoolTeacher.options}
                                isLoading={schoolTeacher.isLoading}
                                label="Teacher"
                                isRequired={true}
                                // onValueChange={(newValue) => {
                                //     setSelectedTeachers((prev) => {
                                //         const exists = prev?.find((item) => item?.id === newValue?.id);
                                //         return exists ? prev : [...prev, newValue];
                                //     });
                                //     setFieldValue("teacher_ids", "")
                                // }}
                                onValueChange={(newValue) => {
                                    // ❌ ignore empty selections
                                    if (!newValue || !newValue.id) return;

                                    // 1️⃣ Update selectedTeachers (avoid duplicates)
                                    setSelectedTeachers((prev = []) => {
                                        const exists = prev.find((item) => item.id === newValue?.id);
                                        return exists ? prev : [...prev, newValue];
                                    });

                                    // 2️⃣ Update Formik teacher_ids correctly
                                    setFieldValue("teacher_ids", (prev = []) => {
                                        const exists = prev.includes(newValue?.id);
                                        return exists ? prev : [...prev, newValue?.id];
                                    });



                                }}

                            />
                        </Grid2>
                    </Grid2>
                    <CustomDivider />
                    <Grid2 container spacing={Grid_Gap}>
                        <Grid2 children size={Input_Width} >
                            <Button variant='outlined' fullWidth onClick={() => { resetForm() }}
                                disabled={mutation.isPending}

                            >Cancel</Button>
                        </Grid2>
                        <Grid2 children size={Input_Width}>
                            <Button variant='contained' fullWidth type="submit"
                                disabled={mutation.isPending}

                            >
                                {mutation.isPending ? "Submitting..." : "Submit"}
                            </Button>
                        </Grid2>
                    </Grid2>



                </Form>
            )}
        </Formik>
    )
}

export default AssignCourseToTeacher
